'use client';

import { useTranslations } from 'next-intl';
import { useAuthContext } from '@/lib/auth/AuthProvider';
import { Link } from '@/lib/routing';
import { Button } from '@/lib/ui-kit-v2/button';

export function EventNoWinnerBanner() {
  const t = useTranslations('event.noWinner');
  const { isAuthenticated } = useAuthContext();

  return (
    <div className="mt-6 flex flex-col gap-4 rounded-[10px] bg-v2-surface-secondary px-8 py-6 shadow-v2-card">
      <span className="text-[15px] font-semibold leading-5 text-v2-text-primary">{t('title')}</span>
      <span className="text-[13px] leading-5 text-v2-text-secondary">{t('description')}</span>
      {isAuthenticated && (
        <Button appearance="accent" size="S" className="w-fit" asChild>
          <Link href="/account?tab=deals">{t('checkTheDeals')}</Link>
        </Button>
      )}
    </div>
  );
}
